import { gql } from '@apollo/client';

export const UPDATE_PLACE_COORDINATES = gql`
mutation UpdatePlaceCoordinates($id: String!, $x: Float!, $y: Float!) {
    updatePlace(id: $id, data: { coordinateX: $x, coordinateY: $y }) {
        id
        coordinateX
        coordinateY
    }
  }
`;

export const CREATE_PLACE = gql`
mutation CreatePlace($name: String!, $coordinateX: Float!, $coordinateY: Float!, $sectionId: ID!) {
    createPlace(data: { name: $name, coordinateX: $coordinateX, coordinateY: $coordinateY, sectionId: $sectionId }) {
        id
        coordinateX
        coordinateY
        name
    }
  }
`;

export const REMOVE_PLACE = gql`
mutation RemovePlace($id: String!) {
    removePlace(id: $id)
  }
`;

export const UPDATE_PLACE_NAME = gql`
mutation UpdatePlaceName($id: String!, $name: String! $isToGo: Boolean!) {
    updatePlace(id: $id, data: { name: $name, isToGo: $isToGo }) {
        id
        name
        isToGo
    }
  }
`;

export const UPDATE_SECTION_NAME = gql`
mutation UpdateSectionName($id: String!, $name: String!) {
    updateSectionName(id: $id, data: { name: $name }) {
        id
        name
    }
  }
`;

export const UPDATE_SECTION_ORDER = gql`
mutation UpdateSectionOrder($orderedSections: [SectionWithOrder!]!) {
    updateSectionsOrdering(data: { orderedSections: $orderedSections }) {
        id
        ordering
    }
  }
`;

export const CREATE_SECTION = gql`
mutation CreateSection{
    createSection{
      id
      name
      createdAt
      ordering
    }
  }
`;

export const DELETE_SECTION = gql`
mutation DeleteSection($id: String!) {
  removeSection(id: $id)
}
`;
